/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injectable } from '@angular/core';

import { iif, Observable, of } from 'rxjs';
import { defaultIfEmpty, filter, map, switchMap, take } from 'rxjs/operators';
import { Select } from '@ngxs/store';
import { DigitizePointConfigState } from './state/digitize-point-config.state';
import { DigitizableLayer } from './state/digitize-point-config.model';

@Injectable({providedIn: 'root'})
export class DigitizePointConfigService {

    @Select(DigitizePointConfigState.loaded) loaded$: Observable<boolean>;
    @Select(DigitizePointConfigState.layers) layers$: Observable<DigitizableLayer[]>;

    constructor() {}

    public getLayer(layerName): Observable<DigitizableLayer> {
        const empty: DigitizableLayer = {
            create: false,
            delete: false,
            move: false,
            displayName: '',
            keyfield: '',
            layer: layerName
        };
        const whenLoaded$ = this.layers$.pipe(
            take(1),
            map((layers: DigitizableLayer[]) => layers.find(l => l.layer === layerName)),
            filter(layer => layer !== undefined),
            defaultIfEmpty(empty)
        );
        return this.loaded$.pipe(
            switchMap(loaded => iif(() => loaded, whenLoaded$, of(null)))
        );
    }
}
